import { Br } from "@/components/molecules/Br";
import { Inner } from "@/components/molecules/Inner";
import Image from "next/image";
import Link from "next/link";
import CoverPri from "/public/cover-pri.webp";
import CoverSec from "/public/cover-sec.webp";
import IdentityLine from "/public/identity-line.svg";

const IdentityNav = ({ showGuidelinesLink, showCultureLink }) => {
  return (
    <>
      <Inner className="mx-auto box-border flex w-full flex-col">
        <div className="relative flex aspect-[9.9375/1] h-auto w-full items-center justify-center md:-mb-4">
          <h4 className="relative z-10 text-center font-bold text-ter fluid-text-[11px,16px]">
            私たちは、行動指針、および価値観・カルチャーを
            <Br sp />
            アイデンティティーとして定めています
          </h4>
          <div className="absolute top-0 left-0 z-0 aspect-[9.9375/1] h-auto w-full max-w-7xl">
            <Image
              src={IdentityLine}
              alt="Identity"
              quality={80}
              layout="fill"
            />
          </div>
        </div>
        <div className="grid w-full grid-cols-1">
          {showGuidelinesLink && (
            <Link href="/identity/guidelines/">
              <div className="relative col-span-1 cursor-pointer overflow-hidden p-6 transition-all hover:brightness-110 md:p-12 md:pt-40">
                <div className="">
                  <div className="relative z-10 space-y-4 text-white">
                    <h3 className="font-serif font-bold fluid-text-[22px,32px]">
                      行動指針
                    </h3>
                    <div className="fluid-text-[12px,18px]">
                      私たちは、より良い顧客価値を創造するために、
                      <Br />
                      当社の定める行動指針に基づいて、行動および判断をします
                    </div>
                  </div>
                  <div className="absolute top-1/2 left-1/2 z-0 aspect-[4.24/1] h-[300px] w-auto -translate-x-1/2 -translate-y-1/2">
                    <Image src={CoverPri} quality={80} layout="fill" />
                  </div>
                </div>
              </div>
            </Link>
          )}
          {showCultureLink && (
            <Link href="/identity/culture/">
              <div className="relative col-span-1 cursor-pointer overflow-hidden p-6 transition-all hover:brightness-110 md:p-12 md:pt-40">
                <div className="">
                  <div className="relative z-10 space-y-4 text-white">
                    <h3 className="font-serif font-bold fluid-text-[22px,32px]">
                      価値観・カルチャー
                    </h3>
                    <div className="fluid-text-[12px,18px]">
                      私たちは、事業を推進していくため、
                      <Br sp />
                      仲間とともに充実した
                      <Br tbpc />
                      職業人生を歩んでいくための価値観・カルチャーを共有します
                    </div>
                  </div>
                  <div className="absolute top-1/2 left-1/2 z-0 aspect-[4.24/1] h-[300px] w-auto -translate-x-1/2 -translate-y-1/2">
                    <Image src={CoverSec} quality={80} layout="fill" />
                  </div>
                </div>
              </div>
            </Link>
          )}
        </div>
      </Inner>
    </>
  );
};

export default IdentityNav;
